import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select'

export type BillingCycle =
  | 'current'
  | 'previous'
  | 'last_1h'
  | 'today'
  | 'yesterday'
  | 'last_24h'
  | 'last_7_days'
  | 'last_14d'
  | 'last_30_days'
  | 'last_90d'
  | 'last_180d'
  | 'this_month'
  | 'year_to_date'
  | 'all_time'
  | 'custom_range'

interface BillingCycleSelectorProps {
  value?: BillingCycle
  onValueChange: (value: BillingCycle) => void
  className?: string
}

export function BillingCycleSelector({
  value = 'current',
  onValueChange,
  className,
}: BillingCycleSelectorProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder='Select time range' />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value='current'>
          <div className='flex items-center gap-2'>
            <div className='w-2 h-2 bg-gray-400 rounded-full'></div>
            Current billing cycle
          </div>
        </SelectItem>
        <SelectItem value='previous'>Previous billing cycle</SelectItem>
        <SelectItem value='last_1h'>Last 1 hour</SelectItem>
        <SelectItem value='today'>Today</SelectItem>
        <SelectItem value='yesterday'>Yesterday</SelectItem>
        <SelectItem value='last_24h'>Last 24 hours</SelectItem>
        <SelectItem value='last_7_days'>Last 7 days</SelectItem>
        <SelectItem value='last_14d'>Last 14 days</SelectItem>
        <SelectItem value='last_30_days'>Last 30 days</SelectItem>
        <SelectItem value='last_90d'>Last 90 days</SelectItem>
        <SelectItem value='last_180d'>Last 180 days</SelectItem>
        <SelectItem value='this_month'>This month</SelectItem>
        <SelectItem value='year_to_date'>Year to date</SelectItem>
        <SelectItem value='all_time'>All time</SelectItem>
        <SelectItem value='custom_range'>Custom date range...</SelectItem>
      </SelectContent>
    </Select>
  )
}
